import anime from 'animejs/lib/anime.es.js';
export default {
    /**
     * 如下是非专用 动画
     */
    // 数字激增
    numberIncr(target, originalNum, finalNum, round = 10) {
        anime({
            targets: target,
            innerHTML: [originalNum, finalNum],
            easing: 'easeInOutQuad', // 更适合快到慢的效果
            round: round,
            duration: 800,
        });
    },


    /**
     * 闪烁提醒某个div
     * @param className
     * @param times 闪烁次数
     */
    flashBorder(className,times = 2) {
        anime({
            targets: className,
            borderColor: ['#fff', '#f00', '#fff'], // 渐变颜色
            duration: 500, // 单次动画持续时间
            easing: 'linear',
            loop: times, // 动画循环两次
        });
    },

    /**
     * 抖动提醒某个div
     * @param className
     * @param weight 抖动幅度
     */
    shakeElement(className,weight = 1) {
        anime({
            targets: className,
            translateX: [
                { value: 10 * weight, duration: 50, easing: 'easeInOutSine' },
                { value: -10 * weight, duration: 50, easing: 'easeInOutSine' },
                { value: 5 * weight, duration: 50, easing: 'easeInOutSine' },
                { value: -5 * weight, duration: 50, easing: 'easeInOutSine' },
                { value: 2.5 * weight, duration: 50, easing: 'easeInOutSine' },
                { value: -2.5 * weight, duration: 50, easing: 'easeInOutSine' },
                { value: 0, duration: 50, easing: 'easeInOutSine' }
            ],
            loop: 1 // 动画只执行一次
        });
    }


};



